import React, { useRef } from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../styles/breakpoints";

import { ReactComponent as SushiMenuSvg } from "../../../assets/icons/Icon/DKT/Menu/Sushi 9er Full black.svg";
import { OpenableContainer } from "../../../components/_shared-components/generic-listing-page/OpenableContainer";
import styled from "@emotion/styled";
import { SwarovskiLink } from "../../../components/_shared-components/ui-elements/SwarovskiLink";
import { FONTS, fontSize } from "../../../styles/fonts";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../components/T";

export const ProductListingPageCategorySelector: ReactTFC<{
  elements: Array<{ key: string; className: string | undefined; name: TranslatedValue | string; path: string }>;
  label: TranslatedValue;
}> = props => {
  return (
    <OpenableContainer label={<T>{props.label}</T>} IconComponent={SushiMenuSvg}>
      <StyledUl count={props.elements.length}>
        {props.elements.map(category => {
          return (
            <li className={category.className} css={liStyles} key={category.key}>
              <SwarovskiLink
                link={category.path}
                isInternal={true}
                scrollToTop={false}
                expectSimilarLayout={true}
                attachStyles={linkStyles}
              >
                <T>{category.name}</T>
              </SwarovskiLink>
            </li>
          );
        })}
      </StyledUl>
    </OpenableContainer>
  );
};

const StyledUl = styled.ul<{ count: number }>`
  margin: 0;
  padding: 0;
  list-style-type: none;

  ${CSS_MQ.atMostSm} {
    display: none;
    .opened & {
      display: block;
    }
  }

  ${CSS_MQ.atLeastMd} {
    display: grid;
    justify-content: space-between;

    grid-column-gap: 20px;
    grid-template-columns: repeat(${props => props.count}, 1fr);
  }
`;

const liStyles = [
  FONTS.SwarovskiFutura500,
  fontSize.x2,
  css`
    display: flex;
    text-align: center;
    flex-grow: 1;

    justify-content: flex-start;

    ${CSS_MQ.atLeastMd} {
      justify-content: center;
    }
  `,
];

const linkStyles = css`
  display: block;

  text-transform: uppercase;
  text-decoration: none;
  line-height: 1.1;

  color: ${CSS_COLORS.Black};

  padding: 10px 0;

  ${CSS_MQ.atMostSm} {
    width: 100%;
    text-align: left;

    padding-left: 18px;
    padding-right: 18px;

    .active &,
    &:hover {
      color: ${CSS_COLORS.Green};
    }
  }

  ${CSS_MQ.atLeastMd} {
    width: 100%;
    padding-top: 16px;

    border-top: 2px solid currentColor;

    color: ${CSS_COLORS.Grey2};

    .active & {
      color: ${CSS_COLORS.Black};
    }
  }
`;
